export class Gasto{
    constructor(nome,valor,mes){
        this.id = crypto.randomUUID()
        this.nome = nome;
        this.valor = valor;
        this.mes = mes;
    }
}